var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextCopy = function SvgTextCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#textCopy_svg__a)",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.25 5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3.75 15.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.25 15.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3.75 5.25v7.5M5.25 3.75h7.5M5.25 14.25h7.5M14.25 5.25v7.5",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5h3M9 10.5v-3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "textCopy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgTextCopy;